import { css } from '@emotion/react';
import React from 'react';

import { COLORS2, LAYOUT2, TYPOGRAPHY2 } from '../../../Styles';

const SELECTED_BAR_WIDTH = 8;

const MENU_ITEM_STYLE = css`
  label: MENU_ITEM_STYLE;
  ${TYPOGRAPHY2.xSmall};
  display: flex;
  align-items: center;
  margin: 0 ${LAYOUT2.spacing2}px 0 ${LAYOUT2.spacing2}px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  color: ${COLORS2.alwaysDark.text.green};

  &:hover {
    background-color: ${COLORS2.alwaysDark.background.black};
  }
`;

const CHILDREN_WRAPPER_STYLE = css`
  label: CHILDREN_WRAPPER_STYLE;
  display: flex;
  flex: 1;
  align-items: center;
`;

const CHILDREN_WRAPPER_BOX_STYLE = css`
  label: CHILDREN_WRAPPER_BOX_STYLE;
  padding: ${LAYOUT2.spacing1p5}px;
  padding-left: ${SELECTED_BAR_WIDTH}px;
`;

const MENU_ITEM_LEFT_SELECT_BAR_STYLE = css`
  label: MENU_ITEM_LEFT_SELECT_BAR_STYLE;
  width: ${SELECTED_BAR_WIDTH}px;
  height: 100%;
  background-color: ${COLORS2.alwaysDark.primary};
  margin-right: ${SELECTED_BAR_WIDTH}px;
  transition: width 0.2s ease;
`;

const MENU_ITEM_LEFT_SELECT_BAR_HIDDEN_STYLE = css`
  label: MENU_ITEM_LEFT_SELECT_BAR_HIDDEN_STYLE;
  width: 0;
`;

const MENU_ITEM_BOX_STYLE = css`
  border: 1px solid ${COLORS2.alwaysDark.border.darkGray};
`;

const MENU_ITEM_BORDER_BOTTOM_STYLE = css`
  label: MENU_ITEM_BORDER_BOTTOM_STYLE;
  border-bottom: 1px solid ${COLORS2.alwaysDark.border.darkGray};
`;

export const ScanNavigatorItem = ({
  children,
  isSelected,
  onSelect,
  showBox,
}: {
  showBox?: boolean;
  children?: React.ReactNode;
  isSelected?: boolean;
  onSelect?: () => void;
}) => {
  const minHeight = LAYOUT2.mediumButtonHeight;
  return (
    <div
      css={[
        MENU_ITEM_STYLE,
        showBox ? MENU_ITEM_BOX_STYLE : MENU_ITEM_BORDER_BOTTOM_STYLE,
      ]}
      onClick={e => {
        e.stopPropagation();
        onSelect?.();
      }}
      style={{ minHeight }}
    >
      <div css={[MENU_ITEM_LEFT_SELECT_BAR_STYLE, isSelected ? undefined : MENU_ITEM_LEFT_SELECT_BAR_HIDDEN_STYLE]} style={{ minHeight }} />
      <div
        css={[
          CHILDREN_WRAPPER_STYLE,
          showBox
            ? CHILDREN_WRAPPER_BOX_STYLE
            : undefined,
        ]}
      >
        {children}
      </div>
    </div>
  );
};
